<template>
  <div id="devAccLog">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>手持机日志</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               style="height: 42px;">
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户::">
              <el-select v-model="pageSearch.fCustID"
                         filterable
                         placeholder="请选择客户"
                         :clearable="true"
                         style="width:200px;">
                <el-option v-for="item in cust_list"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备编号或操作员::">
              <el-input placeholder="请输入设备编号或操作员"
                        v-model="pageSearch.fDevLinkman"
                        class="search">
              </el-input>
            </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
            <el-form-item label="">
              <el-button type="primary"
                         size="small"
                         icon="el-icon-search"
                         @click="page_list">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="150">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                           label="操作时间"
                           width="160">
          </el-table-column>
          <el-table-column prop="fDevAccNo"
                           width="150"
                           label="操作员编号">
          </el-table-column>
          <el-table-column prop="fDevLinkman"
                           width="150"
                           label="操作员姓名">
          </el-table-column>
          <el-table-column prop="fLogDate"
                           width="160"
                           label="日志日期">
          </el-table-column>
          <el-table-column prop="fLogUrl"
                           label="日志URL">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="260">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleOpen(scope.$index, scope.row)">打开</el-button>
              <!-- <el-link target="_blank" :href="scope.row.fLogUrl | filterUrl" :underline="false" style="margin-left:15px">
                  <el-button size="mini" type="primary">下载</el-button></el-link> -->
              <el-button size="mini"
                         type="primary"
                         @click="handleDownload(scope.$index, scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { device } from '../../api/device'
import * as park from '../../api/park'
// import $ from 'jquery'
export default {
  data () {
    return {
      startTime: '',
      endTime: '',
      is_export: false,
      pageData: [],
      cust_list: [],
      loading: false,
      tableHeight: 0,
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fDevLinkman: '',
        fStartTime: '',
        fEndTime: ''
      }
    }
  },
  methods: {
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm')
      device.devAccLogPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    init () {
      // if (this.pageSearch.fStartTime instanceof Date) {
      //   this.pageSearch.fStartTime = this.$dateFormat(this.pageSearch.fStartTime, 'yyyy-MM-dd hh:mm')
      // }
      // if (this.pageSearch.fEndTime instanceof Date) {
      //   this.pageSearch.fEndTime = this.$dateFormat(this.pageSearch.fEndTime, 'yyyy-MM-dd hh:mm')
      // }
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59)
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm')
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data || []
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fBatchID === '1') {
        return 'warning-row'
      }
      return ''
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
    },
    handleOpen (index, row) {
      window.open(row.fLogUrl, '_blank')
    },
    handleDownload (index, row) {
      if (!row.fLogUrl) {
        return
      }
      device.devAccLogDownLoad({ fLogUrl: row.fLogUrl }).then(res => {
        // this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            let fileName = data.Data.name
            let url = window.URL.createObjectURL(new Blob([data.Msg]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(url)
            // this.$message({
            //   message: '下载成功',
            //   type: 'success'
            // })
          } else {
            this.$message({
              message: '下载失败',
              type: 'error'
            })
            // this.$message.error('提示：' + data.Msg)
          }
        }
      })
    }
  },
  created () {
    // user.getCurrentUserPers({ perTypeId: 72000 }).then(res => {
    //   if (res && res.data) {
    //     var data = res.data
    //     if (data.IsOk) {
    //       if (data.Data) {
    //         this.is_export = data.Data.data.is_export
    //       }
    //     } else {
    //       this.$message.error('提示：加载当前用户权限信息失败')
    //     }
    //   }
    // })
  },
  mounted () {
    var today = new Date()
    this.pageSearch.fStartTime = this.$dateFormat(today, 'yyyy-MM-dd') + ' 00:00'
    this.pageSearch.fEndTime = this.$dateFormat(today, 'yyyy-MM-dd') + ' 23:59'
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
</style>
<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.tip {
  text-align: center;
  position: absolute;
  top: 12px;
  right: 40px;
}
.log_search {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/devAccLog.vue